var areValuesEqual = function areValuesEqual(val1, val2, valueAccessor) {
  var getValue = function getValue(val) {
    if (typeof valueAccessor === 'string') {
      return val[valueAccessor];
    }

    if (typeof valueAccessor === 'function') {
      return valueAccessor(val);
    }
  };

  if (val1 instanceof Object && val2 instanceof Object) {
    if (val1.constructor === Object && val2.constructor === Object) {
      return getValue(val1) === getValue(val2);
    }

    if (Array.isArray(val1) && Array.isArray(val2)) {
      var valMapping = function valMapping(val) {
        if (typeof val === 'string') {
          return val;
        }

        if (val instanceof Object && val.constructor === Object) {
          return getValue(val);
        }
      };

      var val1String = val1.map(valMapping).join('');
      var val2String = val2.map(valMapping).join('');
      return val1String === val2String;
    }
  }

  return val1 === val2;
};

export default areValuesEqual;